import type { DuplicateFlag } from '../types';
import { describeFlagDates, describeOtherRun, matchLabel } from './duplicateText';

/** Employees in this run who are also in another live run for the same period or pay day. A warning, never a block: a correction or bonus run can share a
 * period, so the preparer is asked to acknowledge each one (with a reason) when sending the run for approval. */
export function DuplicateFlagsNotice({ flags }: { flags: DuplicateFlag[] }) {
  if (flags.length === 0) return null;
  return (
    <div className="cpr-notice cpr-notice--warning" role="status" data-testid="employee-duplicate-flags">
      <strong>
        {flags.length} {flags.length === 1 ? 'employee is' : 'employees are'} also in another run for this period or pay day
      </strong>
      <ul>
        {flags.map((f) => (
          <li key={`${f.employeeId}-${f.otherRunId}`}>
            {f.firstName} {f.lastName} — {describeOtherRun(f)}, {matchLabel(f.match)} ({describeFlagDates(f)}).
            {f.otherRunIsApproved && <strong> That run is already approved.</strong>}
          </li>
        ))}
      </ul>
      <p>You can still continue. You will be asked to confirm each one, with a reason, when you send this run for approval.</p>
    </div>
  );
}
